module.exports = __webpack_public_path__ + "static/media/wash@2x.8cf5fa12.jpg";